<template>
  <section>
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-lg-12 mb-3" v-scroll-reveal.reset="{ delay: 0 }">
          <div class="d-flex justify-content-between align-items-center">
            <h3>Semua PO yang tersedia</h3>
            <div class="form-group">
              <select class="custom-select">
                <option selected>Urutkan berdasarkan</option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </select>
              <img
                src="assets/img/icons/interface/icon-caret-down.svg"
                alt="Arrow Down"
                class="icon icon-sm"
              />
            </div>
            <div class="form-group">
              <input class="form-control" placeholder="Pencarian" type="text" />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-lg-3 mb-3 mb-lg-5" v-for="listProducts in products" v-bind:key="listProducts.id" v-scroll-reveal.reset="{ delay: 300 }">
          <div class="card hover-box-shadow">
            <a href="#" class="d-block bg-gradient rounded-top">
              <img
                class="card-img-top hover-fade-out"
                v-bind:src="listProducts.productimage"
                alt="blog.5.image"
              />
            </a>
            <div class="card-body">
              <h5> {{ listProducts.produtname }} </h5>
              <p class="description-products">
                {{ listProducts.poname }}
              </p>
              <p class="primary lead">
                <strong> {{ listProducts.price }} </strong>
              </p>
              <p style="font-size: 12px;"></p>
              <div class="d-flex justify-content-between align-items-center">
                <a href="#" class="badge badge-pill badge-info">Pre-Order</a>
                <div class="text-small text-muted"> {{ listProducts.date }} </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: "ListProduk",
  data: function() {
    return {
      products: [
        {
          id: 1,
          seller: 'Pipit Agustin',
          location: 'Surabaya',
          produtname: 'Soto Ayam Lamongan Cak Kan',
          poname: 'Open P.O oleh-oleh express khas Bali',
          price: 'Rp 15,000',
          date: '30 Hari Lagi',
          productimage: 'assets/img/products/product-01.png'
        },
                {
          id: 1,
          seller: 'Pipit Agustin',
          location: 'Surabaya',
          produtname: 'Sate Ayam & Kambing Cak Hari - Kebon Sirih',
          poname: 'Open P.O oleh-oleh express khas Bali',
          price: 'Rp 15,000',
          date: '30 Hari Lagi',
          productimage: 'assets/img/products/product-02.png'
        }
      ]
    };
  }
};
</script>